<!--  -->
<template>
  <div class="allCountry" v-loading.fullscreen.lock="fullscreenLoading">
    <multi></multi>
    <h3>全球招标信息一站收集</h3>
    <ul class="tabs">
      <li
        @click="country(item.id,index)"
        v-for="(item,index) in tablist"
        :key="item.id"
        :class="activeIndex==index?'active':''"
      >{{ item.name }}</li>
    </ul>
    <div class="countryList" v-for="(item, index) in countryList" :key="index">
      <h4>{{ item[0] }}</h4>
      <ul>
        <li v-for="(items, index) in item[1]" :key="index" @click="gotoFind(items.othercountry)">
          <span class="left">{{ items.nationalFlag.chinesecountry }}</span>
          <img :src="`http://182.61.21.235/images/${items.nationalFlag.nfaddress}`" alt />
          <span class="right">{{ items.blbt }}</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import { API_1, Global } from '@/conf/api'
import multi from '../components/header.vue'
export default {
  //import引入的组件需要注入到对象中才能使用
  name: 'allCountry',
  components: { multi },
  data() {
    //这里存放数据
    return {
      countryList: [],
      nameList: [],
      fullscreenLoading: false,
      tablist: [
        {
          id: 6,
          name: '亚洲',
        },
        {
          id: 5,
          name: '欧洲',
        },
        {
          id: 3,
          name: '非洲',
        },
        {
          id: 1,
          name: '北美洲',
        },
        {
          id: 2,
          name: '大洋洲',
        },
        {
          id: 4,
          name: '南美洲',
        },
      ],
      activeIndex: 0,
    }
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    gotoFind(val) {
      //跳转搜索页
      this.$router.push({
        path: 'find',
        query: { country: val },
      })
    },
    country(val, index) {
      //1北美2大洋洲3非洲4南美5欧洲6亚洲
      this.activeIndex = index
      let params = {
        continent: val,
      }
      this.axios
        .get(API_1 + Global.country, { params: params })
        .then((res) => {
          this.fullscreenLoading = false
          this.countryList = Object.entries(res.data.data)
        })
        .catch((res) => {
          console.log(res)
        })
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.country(6)
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.activeIndex = 0
  },
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang="scss" scoped>
  //@import url(); 引入公共css类
  .allCountry {
    background: url('../assets/listbg.jpg') repeat-y top left;
    background-size: 100% auto;
    h3 {
      margin-top: 20px;
    }
    .tabs {
      margin: 50px auto 0;
      .active {
        background: #0f4d72;
        color: #fff;
      }
      li {
        display: inline-block;
        width: 120px;
        margin: 10px 30px;
        border: 1px solid #0f4d72;
        cursor: pointer;
        border-radius: 4px;
        padding: 5px 0px;
        text-align: center;
        &:hover {
          background: #0f4d72;
          color: #fff;
        }
      }
    }
    .countryList {
      background: transparent;
      font-size: 16px;
      width: 1020px;
      margin: 50px auto 0;
      h4 {
        margin-bottom: 20px;
        font-size: 20px;
      }
      ul {
        text-align: left;

        li {
          display: inline-block;
          margin-bottom: 20px;
          width: 250px;
          cursor: pointer;
          font-size: 14px;
          text-align: center;
          color: #0f4d72;
          height: 30px;
          &:hover {
            .left {
              color: #3981b1;
            }
          }
          img {
            width: 35px;
            height: 20px;
          }
          .left {
            float: left;
            display: inline-block;
            text-align: right;
            width: 100px;
          }
          .right {
            float: right;
            display: inline-block;
            text-align: left;
            width: 70px;
          }
        }
      }
    }
  }
</style>
